
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"13","height":"23","viewBox":"0 0 13 23"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.8 4L6.5 0 3.2 4l.7.6L6 2.1v13h1v-13l2.1 2.5z"}}),_c('path',{attrs:{"d":"M13 23H0V8h5v1H1v13h11V9H8V8h5z"}})])
          )
        }
      }
    